import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuisbewaringAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8C9E9"
      fillRule="evenodd"
      d="M20 17.7c3.31 0 6 2.69 6 6v10.6H14V23.7c0-3.31 2.69-6 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#F8C9E9"
      d="M20.03 17.7a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F29FC5"
      fillRule="evenodd"
      d="m20.23 20.1 13.06 4.75-2.31 6.35-4.23-1.54.77-2.12-8.82-3.21a6.75 6.75 0 0 1-7.53 2.05 6.76 6.76 0 0 1-4.04-8.66 6.76 6.76 0 0 1 8.66-4.04 6.78 6.78 0 0 1 4.45 6.41z"
      clipRule="evenodd"
    />
    <path
      fill="#F8C9E9"
      d="M13.47 22.28a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuisbewaringAanvragen);

export default ForwardRef;
